import { Button, Form, Input, DatePicker, message } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import ReactQuill from "react-quill";
import {
    addDoc,
    collection,
    doc,
    getCountFromServer,
    getDocs,
    setDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import moment from "moment";

const AddBlog = () => {
    const [bodyText, setBodyText] = useState("");
    const [id, setId] = useState();
    const getLength = async () => {
        const blogsColl = collection(db, "blogs");
        getDocs(blogsColl).then((res) => {
            setId(
                res.docs.map((doc) => {
                    return doc.data();
                }).length + 1
            );
        });
    };

    useEffect(() => {
        getLength();
    }, []);
    const quillModules = useMemo(() => {
        return {
            toolbar: {
                container: [
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ font: [] }],
                    [{ align: [] }],
                    ["bold", "italic", "underline"],
                    [
                        { list: "ordered" },
                        { list: "bullet" },
                        {
                            color: [
                                "#8f1b1b",
                                "#000000",
                                "#e60000",
                                "#ff9900",
                                "#ffff00",
                                "#008a00",
                                "#0066cc",
                                "#9933ff",
                                "#ffffff",
                                "#facccc",
                                "#ffebcc",
                                "#ffffcc",
                                "#cce8cc",
                                "#cce0f5",
                                "#ebd6ff",
                                "#bbbbbb",
                                "#f06666",
                                "#ffc266",
                                "#ffff66",
                                "#66b966",
                                "#66a3e0",
                                "#c285ff",
                                "#888888",
                                "#a10000",
                                "#b26b00",
                                "#b2b200",
                                "#006100",
                                "#0047b2",
                                "#6b24b2",
                                "#444444",
                                "#5c0000",
                                "#663d00",
                                "#666600",
                                "#003700",
                                "#002966",
                                "#3d1466",
                                "custom-color",
                            ],
                        },
                        { background: [] },
                        "link",
                    ],
                ],
                handlers: {
                    color: function (value) {
                        if (value == "custom-color")
                            value = window.prompt("Enter Hex Color Code");
                        this.quill.format("color", value);
                    },
                },
            },
        };
    }, []);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const success = () => {
        messageApi.open({
            type: "success",
            content: "The blog has been added",
        });
    };
    return (
        <>
            {contextHolder}
            <h5 style={{ color: "gray" }}>Add a blog:</h5>
            <Form
                form={form}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                layout="horizontal"
                style={{ maxWidth: 900 }}
                onFinish={async (e) => {
                    setDoc(doc(db, "blogs", id.toString()), {
                        ...e,
                        date: moment(e.date).format("DD/MM/YYYY"),
                        body: bodyText,
                        id: id,
                    });
                    form.resetFields();
                    setBodyText("");
                    success();
                }}
                autoComplete="off"
            >
                <Form.Item
                    label="title"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: "Please input Title of the blog!",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Image Link"
                    name="mediumImage"
                    rules={[
                        {
                            required: true,
                            message: "Please input Link of the image!",
                        },
                    ]}
                >
                    <Input></Input>
                </Form.Item>
                <Form.Item
                    label="Date"
                    name="date"
                    rules={[
                        {
                            required: true,
                            message: "Please input creation Date of the blog!",
                        },
                    ]}
                >
                    <DatePicker></DatePicker>
                </Form.Item>
                <Form.Item label="Body">
                    <ReactQuill
                        onChange={(txt) => setBodyText(txt)}
                        modules={quillModules}
                        theme="snow"
                        value={bodyText}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        htmlType="submit"
                        type="primary"
                        size="large"
                        onClick={getLength}
                    >
                        Add blog
                    </Button>
                </Form.Item>
            </Form>
        </>
    );
};
export default AddBlog;
